import type { MonthlyPerformanceSettings } from '@/types/monthlyPerformance'

export const DEFAULT_SEND_AS = 'taylor@thecottagegrocery.com'
export const DEFAULT_FROM_NAME = 'Taylor Rhyne'

export const MEMBERS_PRESET_RECIPIENTS = [
  'partners@thecottagegrocery.com',
  'edwarderhyne@gmail.com',
  'brhyne33@gmail.com',
  'kellerrhyne211@gmail.com',
] as const

export function defaultReportEmailSubject(periodLabel: string): string {
  return `TCG Monthly Financial Review - ${periodLabel}`
}

export function withSendDefaults(
  base: MonthlyPerformanceSettings['email'],
): MonthlyPerformanceSettings['email'] {
  return {
    ...base,
    send_as: base.send_as?.trim() ? base.send_as : DEFAULT_SEND_AS,
    from_name: base.from_name?.trim() ? base.from_name : DEFAULT_FROM_NAME,
  }
}
